import { Box, Text } from '@chakra-ui/react';

interface KeyValueProps {
  label: string;
  value?: React.ReactNode;
}
export const KeyValue: React.FC<KeyValueProps> = ({ label, value }) => (
  <Box>
    <Text fontSize="sm" color="gray.500" mb="1">
      {label}
    </Text>
    <Text>{value ?? '-'}</Text>
  </Box>
);
